module.exports = __webpack_public_path__ + "img/email-check.a71a009a.svg";